import { AxiosResponse } from 'axios';
import { isValidationError, isAccessDeniedError } from '@/common/errorTypes';

export function unwrapResponseData<T>(res: AxiosResponse<T>) {
  return res.data;
}

export function convertErrorToUserMessage(err: any) {
  if (err.response && (err.response.status == 400 || err.response.status == 403)) {
    const data = err.response.data;
    if (isValidationError(data)) {
      return { message: data.message || 'Nieprawidłowe dane' };
    }
    else if (isAccessDeniedError(data)) {
      return {
        message: 'Brak uprawnienia do wykonania operacji',
        originalMessage: data.message
      };
    }
  }

  return {
    message: "Błąd wykonania serwisu",
    originalMessage: err.response && err.response.data && err.response.data.message
  };
}
